import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tradeGraph: null,
  loserGainerList: null,
  mostActiveCategory: null,
  mostActiveDetail: null,
  indices: null,
  news: null,
};

const marketSlice = createSlice({
  name: "market",
  initialState,
  reducers: {
    setMarketDetails: (state, action) => {
      state.mostActiveCategory = action.payload.mostActiveCategory;
      state.mostActiveDetail = action.payload.mostActiveDetail;
      state.indices = action.payload.indices;
    },
    setMarketTradeGraph: (state, action) => {
      state.tradeGraph = action.payload;
    },
    setMarketLoserGainer: (state, action) => {
      state.loserGainerList = action.payload;
    },
    setMarketNews: (state, action) => {
      state.news = action.payload;
    },
  },
});

export const {
  setMarketDetails,
  setMarketLoserGainer,
  setMarketNews,
  setMarketTradeGraph,
} = marketSlice.actions;
export default marketSlice.reducer;
